import React from "react";
import {BonusConfig, Settings, UserBonusView} from "../http/protocol";
import {Modal} from "react-bootstrap";

import getLoggedInRedirect from "../utils/LoggedInRedirect";
import {AppState} from "../RootReducer";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {t} from "../i18n";
import Markdown from "react-markdown";
import {BrandA} from "../ui/buttons/buttons";
import { AccountCard } from "../ui/AccountUI";
import Translator from "../Translator";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import { fetchBalance } from "../user/UserActions";

interface Props {
    settings?:Settings;
    claimedBonus:UserBonusView;
    show:boolean;
    fetchBalance: typeof fetchBalance;
}

interface State {
    startPlaying:boolean;
    show:boolean;
    redirectPath:string;
    redirectText:string;
}


export class BonusClaimedModal extends React.Component<Props, State> {
    constructor(props:Props) {
        super(props);
        this.state = {startPlaying: false, show:false, redirectPath:"/", redirectText: ""}
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if(prevProps.show != this.props.show) {
            this.setState({show: this.props.show});
        }
        if(prevProps.claimedBonus !== this.props.claimedBonus) {
            let product:string = "";
            const conf:BonusConfig = this.props.claimedBonus.bonusConfig || {};

            if(conf.turnoverContributions && conf.turnoverContributions.contributions && conf.turnoverContributions.contributions.length === 1) {
                product = conf.turnoverContributions.contributions[0].product || "";
            }
            this.claimedRedirect(product);
        }
    }


    startPlaying = () => this.setState({startPlaying:true});

    handleClose = () => this.setState({show:false});

    claimedRedirect(product:string) {
        let text:string;
        switch (product) {
            case "POKER":
                text = t("bonus.claimRedirect.poker");
                this.setState({redirectPath: "/poker", redirectText: text});
                break;
            case "SPORTSBOOK":
                text = t("bonus.claimRedirect.sports");
                this.setState({redirectPath: "/sportsbook", redirectText: text});
                break;
            case "CASINO":
                text = t("bonus.claimRedirect.casino");
                this.setState({redirectPath: "/casino", redirectText: text});
                break;
            case "RACING":
                text = t("bonus.claimRedirect.racing");
                this.setState({redirectPath: "/racing", redirectText: text});
                break;
            default:
                text = t("bonus.start-playing");
                const path = this.props.settings ? getLoggedInRedirect(this.props.settings, true) : "/";
                this.setState({redirectPath: path, redirectText: text});
                this.props.fetchBalance();
                break;
        }
    }


    render() {
        if(this.state.startPlaying) {
            return <Redirect to={this.state.redirectPath}/>
        }
        let currency = this.props.settings?.currencies?.find((c) => c.code == this.props.claimedBonus.bonusConfig?.monetaryConfig?.currencyCode)
        let bonusAmount = this.props.claimedBonus.totalBonusAmount;
        const amount = CurrencyFormatter.formatWithSymbol(currency,bonusAmount);

        return(
            <Modal show={this.state.show}
                   onHide={() => this.handleClose()}
                   aria-labelledby="contained-modal-title-vcenter"
                   className="promoteModalDialog bonusClaimed"
                   size="sm">
                <Modal.Title id="contained-modal-title-vcenter" className="promoteModalTitle">
                {this.props.claimedBonus.bonusConfig && this.props.claimedBonus.bonusConfig.name} {t("bonus.claimed")}
                </Modal.Title>
                <Modal.Body className="promoteModalBody">
                    <AccountCard>
                        <div className={"row"}>
                            {this.props.claimedBonus.bonusConfig && this.props.claimedBonus.bonusConfig.imageUrl && <div className={"col-md-2 image"}>
                                <div className={"bonus-image"} style={{ backgroundImage : `url('${this.props.claimedBonus.bonusConfig.imageUrl}')`}}></div>
                            </div>}
                            <div className={"col-md-10 content"}>
                                <h4>
                                    {this.props.claimedBonus.bonusConfig?.translations && <Translator defaultTranslation={this.props.claimedBonus.bonusConfig?.name} translations={this.props.claimedBonus.bonusConfig?.translations.map(t=>({lng : t.language, value : t.name})) as any} />} {amount && amount}
                                </h4>
                                <Markdown className="promoteModalText bonus-claimed-modal-text" children={t("bonus.claimed-message")} />
                            </div>
                        </div>
                    </AccountCard>
                </Modal.Body>
                <Modal.Footer className="promoteModalFooter">
                    <BrandA onClick={() => this.startPlaying()} className={"btn btn-cta"}>
                        {this.state.redirectText}
                    </BrandA>
                    <a href="" onClick={(e) => {e.preventDefault();this.setState({show:false});}}>{t("bonus.back")}</a>
                </Modal.Footer>
            </Modal>
        )
    }
}

const mapStateToProps = (appState : AppState) => {
    return {
        settings : appState.settings.settings,
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
        fetchBalance: () => dispatch(fetchBalance() as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BonusClaimedModal)




